import { createSelector } from '@ngrx/store';

import { getBecomeACustomerState } from '../../become-a-customer-feature.selector';

export const getPartnerId = createSelector(
  getBecomeACustomerState,
  (state) => state.partnerId.partnerId
);
